export default __webpack_public_path__ + "static/media/4-SYNTHESE.5f84e33e.pdf";